<script>
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'
import getInitials from '@/helpers/get-initials'

export default {
  name: 'customer.settings.addresses',
  mixins: [tableMixin],
  props: {
    customer_id: { type: String }
  },
  data () {
    return {
      isLoading: false,
      search: null,
      showForm: false,
      selectedId: null,
      copyId: null,
      fields: [
        {
          key: 'alias',
          label: 'Alias',
          sortable: true,
          class: 'align-middle'
        },
        {
          key: 'attn',
          label: 'Attn.',
          sortable: true,
          thStyle: { width: '200px' },
          class: 'align-middle'
        },
        {
          key: 'address',
          label: 'Address',
          sortable: false,
          class: 'align-middle'
        },
        {
          key: 'is_active',
          label: 'Active',
          thStyle: { width: '100px' },
          class: 'text-center align-middle'
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { width: '100px' },
          class: 'text-right align-middle'
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    customer_id: 'onRefresh',
    search: 'onRefresh',
    showForm: {
      async handler (v) {
        if (!v) this.onRefresh()
      }
    }
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      this.selectedId = null
      this.copyId = null
      let { items, total_rows } = await api.customerAddresses.fetchPage({
        page: 1,
        pageSize: -1,
        needle: this.search,
        orderBy: { created_at: 'asc' },
        filters: [
          { is_active: { _in: [true, false] } },
          { customer_id: { _eq: this.customer_id } }
        ]
      })
      this.data = items.map(csa => ({
        ...csa.address,
        alias: csa.alias,
        is_active: csa.is_active,
        initials: getInitials(csa.address.company_name)
      }))
      this.totalRows = total_rows
      this.isLoading = false
    },
    onEdit (item) {
      this.selectedId = item.id
      this.copyId = null
      this.showForm = true
    },
    onCopy (item) {
      this.selectedId = null
      this.copyId = item.id
      this.showForm = true
    },
    onNewAddress () {
      this.selectedId = null
      this.showForm = true
    },
    async onRemove (address) {
      if (address === undefined) return
      try {
        this.isLoading = true
        /*         await api.addresses.delete({
          id: address.id
        }) */
        await api.customerAddresses.delete({
          address_id: address.id,
          customer_id: this.customer_id
        })
        this.isLoading = false
        this.onRefresh()
      } catch (err) {
        console.error(err)
        this.isLoading = false
      }
    }
  },
  computed: {}
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title">Addresses</h4>

      <b-table
        :show-empty="true"
        hover
        :items="data"
        :fields="fields"
        :busy="isLoading"
        head-variant="primary"
        tbody-tr-class="border-bottom px-2"
        borderless
      >
        <template v-slot:cell(is_active)="{ item }">
          <i class="far fa-check-circle text-success" v-if="item.is_active"></i>
          <i class="fas fa-ban text-danger" v-else></i>
        </template>
        <template v-slot:cell(address)="row">
          {{ row.item.company_name }}, {{ row.item.line1 }},
          <template v-if="row.item.line2">&nbsp;{{ row.item.line2 }},</template>
          {{ row.item.zipcode }} {{ row.item.city }} ({{
            row.item.country_code
          }})
        </template>
        <template v-slot:cell(actions)="row">
          <div class="d-flex align-items-center m-0 p-0">
            <b-button
              variant="outline-dark"
              size="sm"
              @click="onCopy(row.item)"
              class="align-self-center mr-1"
            >
              <i class="far fa-copy"></i>
            </b-button>
            <b-button
              variant="outline-dark"
              size="sm"
              @click="onEdit(row.item)"
              class="align-self-center mr-1"
            >
              <i class="far fa-edit"></i>
            </b-button>
            <b-button
              variant="outline-danger"
              size="sm"
              @click="onRemove(row.item)"
              class="align-self-center"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </div>
        </template>
      </b-table>
      <b-btn class="btn-label" variant="primary" v-on:click="onNewAddress">
        <i class="bx bx-plus label-icon"></i>New Address
      </b-btn>
      <app-address-form-dialog
        :visible.sync="showForm"
        :customerId="customer_id"
        :addressId="selectedId"
        :copyAddressId="copyId"
        ref="address-form"
      />
    </b-card>
  </g-overlay>
</template>
